import React from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import ManageVendorListLayer from './Component/ManageVendorListLayer';

const ManageVendor = () => {
    return (
        <div className="page-wrapper">
            <Breadcrumb
                items={[
                    { label: 'Dashboard', link: '/dashboard' },
                    { label: 'Society Controller', link: '#' },
                    { label: 'Manage Vendor', link: '#', active: true }
                ]}
            />
            <ManageVendorListLayer />
        </div>
    );
};

export default ManageVendor;
